import { INewsDataLocaleItem } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/GameInfo/SteamNewsAndAnnouncements';
import { SUB_TITLE_COLORS } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/GameInfo/SteamNewsAndAnnouncements/_config';

type TLang = 'en' | 'zh' | 'origin';

interface IGetFieldLocaleText {
  data: Record<string, string>;
  field: string;
  lang: TLang;
}

export const getSteamNewsJumpLink = (steamID: string) =>
  steamID ? `https://store.steampowered.com/news/app/${steamID}` : '';

export const getFieldLocaleText = ({ data, field, lang }: IGetFieldLocaleText) => {
  if (lang === 'en') {
    return data[`${field}_en`] || data[field];
  }
  if (lang === 'zh') {
    return data[`${field}_cn`] || data[field];
  }
  return data[field];
};

export const getLocaleList = (data: INewsDataLocaleItem[], selectedLang: TLang) => {
  const localeList = data?.map((item) => {
    return {
      ...item,
      title: getFieldLocaleText({
        data: item as unknown as Record<string, string>,
        field: 'name',
        lang: selectedLang,
      }),
      subTitle: getFieldLocaleText({
        data: item as unknown as Record<string, string>,
        field: 'event_type',
        lang: selectedLang,
      }),
      desc: getFieldLocaleText({
        data: item as unknown as Record<string, string>,
        field: 'description',
        lang: selectedLang,
      }),
    };
  });
  return localeList;
};

export const specifySubtitleColor = (
  data: Record<string, any>[],
  colorMapRef: { current: { [key: string]: string } },
) => {
  data?.forEach((item) => {
    const color = colorMapRef.current[item.event_type];
    const length = Object.keys(colorMapRef.current)?.length || 0;

    if (color) {
      // eslint-disable-next-line no-param-reassign
      item.subTitleColor = color;
    } else {
      const colorIndex = length % SUB_TITLE_COLORS?.length;
      // eslint-disable-next-line no-param-reassign
      colorMapRef.current[item.event_type] = SUB_TITLE_COLORS[colorIndex];
      // eslint-disable-next-line no-param-reassign
      item.subTitleColor = SUB_TITLE_COLORS[colorIndex];
    }
  });
};

export const getType: ({
  isAll,
  isOthers,
  eventType,
}: {
  isAll?: boolean;
  isOthers?: boolean;
  eventType?: string;
}) => string = ({ isAll, isOthers, eventType }) => {
  if (isAll) {
    return 'all';
  }
  if (isOthers) {
    return 'others';
  }
  return eventType as string;
};
